import { Box, TextareaAutosize, Typography } from "@mui/material";
import { Button } from "@mui/material";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: "10px",
  padding: "22px",
};

const NocDetail = ({ open, onOpen, onClose }: any) => {
  return (
    <Box sx={{ textAlign: "center" }}>
      <Typography variant="body1" sx={{ color: "#152536", width: "80%", m: "auto", mt: "5rem" }}>
        We have received your proof of employement and will verify the details from your company.
        Once verification is complete, we will notify you on registered email within 12 hours.
      </Typography>
      <Typography sx={{ mt: "4rem", color: "#152536" }}>
        If there is any issue, Contact our{" "}
        <span onClick={onOpen} style={{ color: "#7FB341", cursor: "pointer" }}>
          Support Center
        </span>{" "}
        for assistance.
      </Typography>

      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="Support" sx={style}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography id="modal-modal-title" variant="h5" component="h2">
              Contact Us
            </Typography>
            <CloseIcon sx={{ cursor: "pointer" }} fontSize="medium" onClick={onClose} />
          </Box>
          <Box
            className="border_line"
            sx={{
              backgroundColor: "#EEEEEE",
              height: "1px",
              mt: "15px",
              mb: 3,
            }}
          ></Box>

          <Box id="modal-modal-description" className="Support_Center_modal" sx={{ mt: 2 }}>
            Do you have any issue, Reach us via email or phone.
            <Box
              className="phoneInfo"
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 4,
                color: "#152536",
                pl: 2,
              }}
            >
              <LocalPhoneIcon />
              <Typography>
                0800 211 8197 <span> - speak to one of or team.</span>
              </Typography>
            </Box>
            <Box
              className="phoneInfo"
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 4,
                color: "#152536",
                pl: 2,
              }}
            >
              <EmailIcon />
              <Typography>
                Use the form below <span> - we aim to respond within 2 working hours.</span>
              </Typography>
            </Box>
            <Box className="How_Help">
              <Typography sx={{ mt: 5, color: "#152536" }}>How can we help?</Typography>
              <TextareaAutosize className="textarea" minRows={5} placeholder="Enter a message" />
            </Box>
            <Box textAlign="right">
              <Button
                onClick={onClose}
                variant="contained"
                className="btn-primary"
                sx={{
                  width: { xs: "100%", md: "auto" },
                }}
              >
                Send
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};
export default NocDetail;
